var React = require('react');
var ReactNative = require('react-native');

var Icon = require('./wrappers/ReUpIcon');

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var QRCodeView = require('./QRCodeView.js');
var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var NetworkManager = require('./NetworkManager.js');
var CheckMarkView = require('./CheckMarkView');
var FadingView = require('./FadingView');
var ReUpButton = require('./ReUpButton');
var ReUpCountdown = require('./ReUpCountdown');
var moment = require('moment');
var {PhysScene, PhysObject} = require('./PhysScene');

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton,
  MKSpinner
} = MK;

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  StyleSheet,
  Vibration,
  Platform,
  TouchableWithoutFeedback,
} = ReactNative;

function getBase64Data(data)
{
  var dataJsonString = JSON.stringify(data);
  var dataBase64 = btoa(dataJsonString);

  return dataBase64;
}

var UseReward = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      reward : {},
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      currentPageIndex : 0,
      shouldShowPrevious : false,
      shouldShowNext : true,
    }
  },

  componentDidMount : function()
  {
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    this.queuePoll();

    if( appManager.isLoggedIn() )
    {
      this._pointsUsed = appManager.currentUser()[ModelConstants.TotalPointsUsedAtScanner];
      this._hash = appManager.currentUser()[ModelConstants.Hash];
    }

    NetworkManager.update(appManager, ['Users'], function()
    {
      // success
    }, function(result)
    {
      appActions.checkErrorCodeAndReturnIfHandled(result.code)
    }, function(data)
    {
      appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
    });
  },

  onScroll: function(offset)
  {
    var others = [];
    if( typeof this.props.extras.reward.others !== 'undefined' )
    {
      others.push(this.props.extras.reward);
      for( var i = 0; i < this.props.extras.reward.others.length; i++ )
      {
        others.push(this.props.extras.reward.others[i]);
      }
      var page = Math.round(offset/(this.state.layout.width))
      if( page != this.state.currentPageIndex )
      {
        this.state.currentPageIndex = page;
        var shouldShowPrevious = page > 0;
        var shouldShowNext = page < (others.length-1);
        this.setState({currentPageIndex:page, shouldShowNext, shouldShowPrevious});
      }
    }
  },

  _pollTimeout : null,
  _isFirstPoll : true,
  _hasExpired : false,
  queuePoll : function()
  {
    var appManager = this.props.appManager;
    var thisThing = this;
    this._pollTimeout = setTimeout(()=>
    {
      if( appManager.isLoggedIn() )
      {
        if( thisThing._hasExpired ) return;

        var isOneTimeReward = typeof thisThing.props.extras.reward.DateExpires !== 'undefined';
        if( isOneTimeReward )
        {
          // if this is a one time reward, check if the quantity has decreased to determine if one has been spent
          var countOfReward = 1 + (typeof thisThing.props.extras.reward.others !== 'undefined' ? thisThing.props.extras.reward.others.length : 0);
          NetworkManager.updateFeature( appManager, "OneTimeRewards", (oneTimeRewards)=>
          {
            thisThing._isFirstPoll = false;
            var numTheseRewards = 0;
            for( var i = 0; i < oneTimeRewards.length; i++ )
            {
              if( oneTimeRewards[i].RewardID == thisThing.props.extras.reward.RewardID ) numTheseRewards++;
            }

            var hasChanged = numTheseRewards != countOfReward;
            if( hasChanged )
            {
              thisThing.announceTransaction(0, thisThing.props.extras.reward.RewardName, true);
            }
            else
            {
              thisThing.queuePoll();
            }
          }, ()=>
          {
            thisThing.queuePoll();
          })
        }
        else
        {
          // if its not a one time reward, then check the points change to determine if there has been a reward used
          NetworkManager.updateFeature( appManager, "User", (user)=>
          {
            if( typeof user !== 'undefined' && user != null && typeof user[ModelConstants.Hash] !== 'undefined' )
            {
              var newHash = user[ModelConstants.Hash];
              var newPointsUsed = user[ModelConstants.TotalPointsUsedAtScanner];
              if( newHash != thisThing._hash || newPointsUsed != thisThing._pointsUsed )
              {
                appManager.setCurrentUser(user, ()=>
                {
                  if( newPointsUsed > thisThing._pointsUsed && !thisThing._isFirstPoll ) thisThing.announceTransaction(newPointsUsed - thisThing._pointsUsed);
                  thisThing._pointsUsed = newPointsUsed;
                  thisThing._hash = newHash;
                  thisThing.forceUpdate();
                });
              }
            }
            thisThing._isFirstPoll = false;
            thisThing.queuePoll();
          }, ()=>
          {
            thisThing.queuePoll();
          })
        }
      }
      else
      {
        thisThing.queuePoll();
      }
    }, 5000);
  },

  didUpdate : function()
  {

  },

  announceTransaction : function(deltaPoints, rewardName = null, shouldPop = false)
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();

    var message = "";
    if( deltaPoints > 0 )
    {
      message = locManager.localizedStringForKeyAndParams("USER_REDEEMED_STATEMENT",
        [locManager.localizedPoints(deltaPoints)]);
    }
    else if( rewardName != null )
    {
      message = locManager.localizedStringForKeyAndParams("USER_REDEEMED_STATEMENT",
        ["1 " + rewardName]);
    }

    var pattern, patternLiteral, patternDescription;
    if (Platform.OS === 'android')
    {
      pattern = [0,2000];
    }
    else
    {
      pattern = [0];
    }
    Vibration.vibrate(pattern)

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var objBG = 'transparent';//appManager.getColorForKey("FeedCardBannerColor");
    var objFG = appManager.getColorForKey("ButtonPrimaryColor");//appManager.getColorForKey("FeedCardBannerIconColor");

    var MAX_OBJECTS = 10;
    var numObjects = Math.abs(deltaPoints);
    while(numObjects > MAX_OBJECTS) numObjects /= 2;

    var renderObject = ()=>{ return <View style={{width:40, height:40, borderRadius:20, backgroundColor:objBG, alignItems:'center', flexDirection:'row', justifyContent:'center'}} ><Icon name={"trophy"} size={40} color={objFG} style={{backgroundColor:'transparent'}} /></View>};
    var objects = [];
    for( var i = 0; i < numObjects; i++ )
    {
      var imod = i%4;
      var velX = (imod == 0 || imod == 1 ? -1 : 1 ) * (0.0005 + 0.0001 * Math.random());
      // var velY = (imod == 0 || imod == 3 ? -1 : 1 ) * (0.0005 + 0.0001 * Math.random());
      var velY = -0.001 + -0.002 * Math.random();
      var startTime = 300+(i+1)*100;
      objects.push({
        posX:.5, posY:.5, velX, velY, renderObject, startTime
      })
    }
    var thisThing = this;
    thisThing._doneButtonFadingView = null;
    setTimeout(()=>
    {
      if( thisThing._doneButtonFadingView ) thisThing._doneButtonFadingView.setFadedOut(false);
    }, 3000)
    // setTimeout(()=>
    // {
    //   if( thisThing.state.renderAlternative )
    //   {
    //     thisThing.setState({renderAlternative:false});
    //     setTimeout(()=>
    //     {
    //       // thisThing.setQRCode();
    //     }, 200)
    //   }
    // }, 30000)
    this.setState({
      renderAlternative:true,
      renderAlternativeView:()=>
        <View style={{backgroundColor:generalColor, flexDirection:'column', alignItems:'center', justifyContent:'center', width:this.state.layout.width, height:this.state.layout.height}}>
        {
          false ?
            <PhysScene
              style={{position:'absolute', top:0, left:0, width:this.state.layout.width, height:this.state.layout.height}}
              objectInfos={objects}/>
          : null
        }
          <View style={{marginHorizontal:20, borderRadius:8, flexDirection:'column', alignItems:'center'}}>
            <View style={{width:100, height:100, flexDirection:'column', marginBottom:20}}>
              <CheckMarkView color={appManager.getColorForKey("FeedCardBannerColor")} style={{flex:1, alignSelf:'stretch'}} />
            </View>
            <ReUpText isTitle={true} appManager={appManager} style={{color:appManager.getColorForKey("FeedCardTitleColor"), backgroundColor:appManager.getColorForKey("FeedCardColor",.6), textAlign:'center'}}>
            {message}
            </ReUpText>
          </View>
          <FadingView ref={(a) => { thisThing._doneButtonFadingView = a }} animDuration={200} style={{height:50, marginHorizontal:20, marginTop:40, alignSelf:'stretch'}}>
            <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("DONE_BUTTON", "Done")} />
          </FadingView>
          <TouchableWithoutFeedback style={{position:'absolute', left:0, right:0, top:0, bottom:0}} onPress={()=>
            {
              if( shouldPop )
              {
                thisThing.props.appActions.requestPop();
              }
              else
              {
                thisThing.setState({renderAlternative:false});
                setTimeout(()=>
                {
                  // thisThing.setQRCode();
                }, 200)                
              }
            }} >
            <View style={{position:'absolute', left:0, right:0, top:0, bottom:0}} />
          </TouchableWithoutFeedback>
        </View>
    })
  },

  render: function()
  {
    var thisRewards = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");
    var tipStatement = locManager.localizedStringForKey("TIP_PERCENTAGE_LABEL");

    var dimension = Math.min(this.state.layout.width-100, this.state.layout.height-164);

    var qrData = {};
    qrData["AppID"] = appManager.getAppInfo()["appid"];
    qrData["Type"] = "reward";
    qrData["U"] = user[ModelConstants.UserID];
    qrData["H"] = user[ModelConstants.Hash];
    qrData["R"] = this.props.extras.reward.RewardID;

    var qrDataBase64 = getBase64Data(qrData);

    var rewardTitle = this.props.extras.reward.RewardName;
    var others = [];
    if( typeof this.props.extras.reward.others !== 'undefined' )
    {
      others.push(this.props.extras.reward);
      for( var i = 0; i < this.props.extras.reward.others.length; i++ )
      {
        others.push(this.props.extras.reward.others[i]);
      }
    }
    others = others.sort(function(a,b)
    {
      if( a.DateExpires == b.DateExpires ) return b.RewardName.localeCompare(a.RewardName);
      else 
      {
        var dateA = new Date(a.DateExpires.replace(' ', 'T')+'Z')
        var dateSecondsA = moment(dateA).valueOf();
        var dateB = new Date(b.DateExpires.replace(' ', 'T')+'Z')
        var dateSecondsB = moment(dateB).valueOf();

        return dateSecondsA - dateSecondsB;
      }
    });
    var shouldShowPageControl = others.length > 1;

    var layout = this.state.layout;

    return (
      <View style={styles.container}
        onLayout={(event)=>this.setState({layout:event.nativeEvent.layout})}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height, backgroundColor: generalColor}]} />

        <ReUpScrollView bounces={true} responder={this} featureName="UseReward"
          renderAlternative={this.state.renderAlternative} renderAlternativeView={this.state.renderAlternativeView}>
          <View style={[styles.instructionContainer, {backgroundColor:instructionColor, color:instructionTitleColor}]}>
            <View style={{flex:1, alignSelf:'center'}}>
              <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[styles.instructionText, {numberOfLines:3, color:instructionTitleColor}]}>
                {rewardTitle}
              </ReUpText>
            </View>
            <View style={{width:50}}>
              <ReUpIconButton type={3}
                appManager={appManager}
                featureData={this.props.featureData}
                appActions={this.props.appActions}
                locParams={[rewardTitle]}
                />
            </View>
          </View>
          <ShadowView appManager={appManager} layout={this.state.layout} />
          <QRCodeView key="qrcode" data={qrDataBase64} dimension={dimension} style={styles.qrcode} spinnerView={<MKSpinner style={{alignSelf : 'center',backgroundColor : 'transparent'}} strokeColor={[generalTitleColor]} />} />
          {
            others.length > 0 ?
              <View>
                <View>
                  <ScrollView ref={(c) => { this._ref_expiryScroll = c; }} horizontal={true} pagingEnabled={true} showsHorizontalScrollIndicator={false} style={{alignSelf:'stretch', height:80}}
                  onScroll={(info) =>
                  {
                    thisRewards.onScroll(info.nativeEvent.contentOffset.x);
                  }}>
                  {
                    others.map((other, index)=>
                    {
                      return <View style={{width:layout.width, height:80, justifyContent:'center', alignItems:'center'}}>
                          <View style={{justifyContent:'center', alignItems:'center', flexDirection:'row'}}>
                            <ReUpText appManager={appManager}>
                            {locManager.localizedStringForKey("EXPIRES_STATEMENT", "Expires ")}
                            </ReUpText>
                            <ReUpCountdown appManager={appManager} endDate={new Date(other.DateExpires.replace(' ', 'T')+'Z')} complete={()=>
                              {
                                thisRewards._hasExpired = true;
                                appActions.showLocalizedAlert(locManager.localizedStringForKey("REWARD_EXPIRED_ALERT_TITLE", "Reward Expired"), locManager.localizedStringForKey("REWARD_EXPIRED_ALERT_DESCRIPTION", "Sorry, this reward has expired."), ["OK_ALERT_BUTTON"], [function()
                                {
                                  appActions.hideAlert();
                                  appActions.requestPop();
                                }], function(){appActions.requestPop()})
                              }} />
                          </View>
                        </View>                  
                    })
                  }
                  </ScrollView>
                  <ReUpButton appManager={appManager} style={{position:'absolute', left:0}} />
                  
                  {
                    this.state.shouldShowPrevious ?
                      <View style={{position:'absolute', left:10, top:0, bottom:0, justifyContent:'center', alignItems:'center'}}>
                        <ReUpIconButton iconName={"angle-left"} appManager={appManager} type={1} onPress={function()
                        {
                          thisRewards._ref_expiryScroll.scrollTo({x:(thisRewards.state.currentPageIndex-1)*layout.width})
                        }} />
                      </View>
                    : null
                  }
                  {
                    this.state.shouldShowNext ?
                      <View style={{position:'absolute', right:10, top:0, bottom:0, justifyContent:'center', alignItems:'center'}}>
                        <ReUpIconButton iconName={"angle-right"} appManager={appManager} type={1} onPress={function()
                        {
                          thisRewards._ref_expiryScroll.scrollTo({x:(thisRewards.state.currentPageIndex+1)*layout.width})
                        }} />
                      </View>
                    : null
                  }
                </View>
                <View style={{flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
                {                  
                  shouldShowPageControl ?
                    others.map(function(page, index)
                    {
                      if( index == thisRewards.state.currentPageIndex )
                      {
                        return <View style={{marginHorizontal:5, width:8, height:8, borderRadius:999, backgroundColor:appManager.getColorForKey("FeedCardBannerColor"),}} />
                      }
                      return <View style={{marginHorizontal:5, width:8, height:8, borderRadius:999, backgroundColor:appManager.getColorForKey("FeedCardTitleColor")}} />
                    })
                  : null
                }
                </View>
              </View>
            : 
              typeof this.props.extras.reward.DateExpires !== 'undefined' ?
                <View style={{justifyContent:'center', alignItems:'center', flexDirection:'row'}}>
                  <ReUpText appManager={appManager}>
                  {locManager.localizedStringForKey("EXPIRES_STATEMENT", "Expires ")}
                  </ReUpText>
                  <ReUpCountdown appManager={appManager} endDate={new Date(this.props.extras.reward.DateExpires.replace(' ', 'T')+'Z')} complete={()=>
                    {
                      appActions.showLocalizedAlert(locManager.localizedStringForKey("REWARD_EXPIRED_ALERT_TITLE", "Reward Expired"), locManager.localizedStringForKey("REWARD_EXPIRED_ALERT_DESCRIPTION", "Sorry, this reward has expired."), ["OK_ALERT_BUTTON"], [function()
                      {
                        appActions.hideAlert();
                        appActions.requestPop();
                      }], function(){appActions.requestPop()})
                    }} />
                </View>
              : null
          }
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
  qrcode: {
    padding: 30,
    alignItems:'center',
  },
  tipContainer: {
    height:50,
    flex:1,
    padding:10,
  },
  tipTypeContainer: {
    height:50,
    width:180,
    alignSelf:'center'
  },
  textField: {
    width:120,
    height:50,
    marginTop:10
  },
  button: {
    justifyContent:'center',
    flex:1,
  },
  tipValueContainer: {
    paddingTop:4,
    paddingLeft:20,
    paddingRight:20,
    alignItems:'center',
    justifyContent:'center',
    flexDirection:'row',
  }
});

UseReward.dataDependencies = ["Rewards", "OneTimeRewards"]

module.exports = UseReward;
